import {
  AppliedFilterSection_Value,
  BrandFilterSection,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {
  FilterLabels,
  FilterSelectedValue,
  FilterType,
} from '@aboutyou/legacy-tracking-sdk';
import {FilterDropdownBrand} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {useBrandSection} from '../../shared/useBrandFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: BrandFilterSection;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    filterSlug?: string;
  }) => void;
  resetFilters: (slug: string[]) => void;
  onOpen: (slug: string, label: FilterLabels) => void;
  onClose: (
    slug: string,
    label: FilterLabels,
    selectedValue?: FilterSelectedValue,
    filterType?: FilterType,
    trackSubmit?: boolean,
  ) => void;
  filterLabel: FilterLabels;
  appliedFilters: (AppliedFilterSection_Value & {isFavorite?: boolean})[];
};

export const FilterSectionBrand: FC<Props> = ({
  activeFilters,
  data,
  setFilter,
  resetFilters,
  onOpen,
  onClose,
  filterLabel,
  appliedFilters,
}) => {
  const {label, slug} = data;
  const {
    activeSlugFilters,
    normalizedBrandGroups,
    excludedBrands,
    favoriteBrandsFilterActive,
    normalizedHighlightedBrands,
    highlightedBrandsLabel,
    highlightedBrandsType,
    onBrandClick,
    handleAllFavoriteBrandsToggle,
    handleSingleFavoriteBrandClick,
    handleFilterReset,
  } = useBrandSection({
    data,
    setFilter,
    resetFilters,
    activeFilters,
  });

  return (
    <FilterDropdownBrand
      activeBrandIds={activeSlugFilters}
      brandGroups={normalizedBrandGroups}
      excludedHighlightedBrands={excludedBrands}
      favoriteBrandsActive={favoriteBrandsFilterActive}
      highlightedBrands={normalizedHighlightedBrands}
      highlightedBrandsLabel={highlightedBrandsLabel}
      highlightedBrandsType={highlightedBrandsType}
      label={label}
      onBrandClick={onBrandClick}
      onFavoriteBrandsToggle={handleAllFavoriteBrandsToggle}
      onHighlightedBrandClick={(id, itemSlug) =>
        handleSingleFavoriteBrandClick(id, itemSlug)
      }
      onFilterReset={handleFilterReset}
      onOpen={() => onOpen(slug, filterLabel)}
      onClose={() => {
        const selectedFavoriteBrands = appliedFilters
          .filter(item => item.isFavorite)
          .map(item => {
            // its always attribute
            if (item.value?.$case === 'attribute') {
              return item.value.attribute.id;
            }
            throw new Error(
              '[Filter section brands] unexpected filter value case',
            );
          });

        if (selectedFavoriteBrands.length) {
          onClose(slug, filterLabel, selectedFavoriteBrands, 'attribute', true);
        } else {
          onClose(slug, filterLabel);
        }
      }}
    />
  );
};
